<template>
	<div>
		<div class="uk-width-1-1 uk-text-center" v-if="layout == 'article'">
			<div v-show="totalComments < 1 && !hideText" class="uk-margin-bottom">
			</div>
			<button v-show="buttonText && !loading && !loaded" class="uk-button uk-button-secondary uk-border-rounded" @click="handleClick">
				{{ buttonText }}
			</button>
		</div>
		<div v-if="layout == 'media' && !hideText" @click="handleClick" style="cursor: pointer">
			<i class="material-symbols-outlined custom-icon">comment</i>
			<span v-show="totalComments > 0">&nbsp; <strong>{{ totalComments }}</strong> reactie <span v-show="totalComments > 1">s</span> tonen</span>
			<span v-show="totalComments == 0"> reageren</span>
		</div>
		<div>
			<div v-show="loading" class="uk-margin-top"><loading-indicator v-show="loading" /></div>
			<div v-html="htmlData"></div>
		</div>
	</div>
</template>

<script>

import axios from 'axios';
import LoadingIndicator from './LoadingIndicator.vue'

export default {
	components: { LoadingIndicator },
	props: {
		url: {
			type: String,
			required: true
		},
		layout: {
			type: String,
			default: 'article',
		},
		totalComments: {
			type: Number,
			required: false
		},
		params: {
			type: Object,
			default: {}
		},
		buttonText: {
			type: String,
			required: false
		},
		targetElement: {
			type: String,
			required: false
		},
		jsVariables: {
			type: Object,
			required: true
		},
		autoLoad: {
			type: Boolean,
			default: false,
			required: false
		}
	},
	data() {
		return {
			hideText: false,
			loading: false,
			loaded: false,
			htmlData: null
		}
	},
	mounted() {
		var component = this;
		if (component.autoLoad) {
			component.$logger('app/components/comments-loader/autoload');
			component.loadContent();
		}
	},
	methods: {
		handleClick() {
			this.hideText = true;
			this.loadContent();
		},
		loadContent() {

			var component = this;

			component.$logger('app/components/comments-loader/loadContent');
			component.$logger('app/components/comments-loader/loadContent/url:' + component.url);
			
			component.loading = true;

			axios({
				method: 'get',
				url: component.url,
				params: component.params
			})
			.then(function (response) {
				
				if(component.targetElement) {
					document.getElementById(component.targetElement).innerHTML = response.data;
				} else {				
					component.htmlData = response.data;
				}	

				component.loading = false;		
				component.loaded = true;	  

				// Init commments, small timeout so elemnts are added to DOM
				setTimeout(function() {
					const commentsRoot = document.querySelector(component.jsVariables.id);
					const commentsForm = commentsRoot?.querySelector('[data-role="form"]');

					if (commentsForm) {
						new Comments.Instance(component.jsVariables.id, component.jsVariables.settings);
					}
				},250);

			})
			.catch(function (e) {
				if(e) {
					console.error(e);
				}
			});		

		}
	}
};
</script>

<style scoped>
</style>
